import React, { FC, useEffect } from "react";

import { useTranslation } from "react-i18next";

import NotAuthenticatedFormLayout from "@/components/layouts/NotAuthenticated/NotAuthenticatedFormLayout";
import { FlowSteps } from "@/components/molecules";
import { InviteFromBrokerState } from "@/shared/domain";
import { useNavigation, useRouterHook } from "@/shared/hooks";

import { InviteFromBrokerSteps, stepperData } from "../InviteFromBroker/utils";
import InviteCheckEmail from "./components/InviteCheckEmail/InviteCheckEmail";

const InviteFromBrokerInfo: FC = () => {
    const {
        state,
        globalState: { officeId },
    } = useRouterHook<InviteFromBrokerState>();

    const { t } = useTranslation();
    const { navToRoot } = useNavigation();

    const { email, date } = state;

    useEffect(() => {
        if (!email) {
            navToRoot();
        }
    }, []);

    return (
        <NotAuthenticatedFormLayout
            officeId={officeId}
            title={t("PageTitles.InviteFromBroker")}
            flowStepsComponent={
                <FlowSteps
                    title={t("Registration.Steps.Title")}
                    availableSteps={stepperData}
                    currentStep={InviteFromBrokerSteps.CHECK_EMAIL}
                />
            }
        >
            <InviteCheckEmail email={email} date={date} officeId={officeId} />
        </NotAuthenticatedFormLayout>
    );
};

export default InviteFromBrokerInfo;
